module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_ucla-450c56f4c3c27ad878b7d27534d462fa.png";